export default (state = { team: [] }, action) => {
  switch (action.type) {
    case "FETCH_USER_COUNTRY_SPECIFIC_TEAM_REQUEST":
      return {
        team: [],
        loading: true,
        userTeamLoading : true,
      };

    case "FETCH_USER_COUNTRY_SPECIFIC_TEAM_SUCCESS":
      return {
        team: action.payload,
        responseDefault: false,
        loading: false,
        success: true,
        error: false,
        userTeamLoading : false,
      };

    case "FETCH_USER_COUNTRY_SPECIFIC_TEAM_FAILURE":
      return {
        team: [],
        error: true,
        responseDefault: false,
        loading: false,
        success: false,
        userTeamLoading : false,
      };

    default:
      return state;
  }
};
